(function () {
  const productCache = new Map();
  let currencyPromise;

  function productHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function routesRoot() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache.has(handle)) {
      const url = routesRoot() + 'products/' + encodeURIComponent(handle) + '.js';
      productCache.set(
        handle,
        fetch(url, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Product price lookup failed');
            return response.json();
          })
          .catch(function () {
            productCache.delete(handle);
            return null;
          })
      );
    }
    return productCache.get(handle);
  }

  function getCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return Promise.resolve(window.Shopify.currency.active);
    }
    if (!currencyPromise) {
      currencyPromise = fetch(routesRoot() + 'cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Currency lookup failed');
          return response.json();
        })
        .then(function (cart) {
          return cart.currency || 'EUR';
        })
        .catch(function () {
          return 'EUR';
        });
    }
    return currencyPromise;
  }

  function formatPrice(cents, currency) {
    const locale = document.documentElement.lang || 'fr-FR';
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' ' + currency;
    }
  }

  function variantIdFromForm(form) {
    const input = form && form.querySelector('input[name="id"]');
    return input ? String(input.value || '') : '';
  }

  function priceRoot(form) {
    return form.closest('.product-page') || form.closest('[data-product-root]') || document;
  }

  function updateDisplayedPrice(form, variant, currency) {
    const root = priceRoot(form);
    const current = root.querySelector('[data-price-current]');
    if (current) current.textContent = formatPrice(variant.price, currency);

    const compare = root.querySelector('[data-price-compare]');
    if (compare) {
      if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        compare.textContent = formatPrice(variant.compare_at_price, currency);
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }
  }

  function syncForm(form) {
    if (!form || !form.matches('form[data-product-form]')) return;
    const requestedId = variantIdFromForm(form);
    const handle = productHandle();
    if (!requestedId || !handle) return;

    Promise.all([getProduct(handle), getCurrency()]).then(function (results) {
      const product = results[0];
      const currency = results[1];
      if (!product || !Array.isArray(product.variants)) return;
      if (variantIdFromForm(form) !== requestedId) return;

      const variant = product.variants.find(function (item) {
        return String(item.id) === requestedId;
      });
      if (!variant) return;

      updateDisplayedPrice(form, variant, currency);
    });
  }

  function syncAll() {
    document.querySelectorAll('form[data-product-form]').forEach(syncForm);
  }

  document.addEventListener('change', function (event) {
    const form = event.target.closest && event.target.closest('form[data-product-form]');
    if (!form) return;
    setTimeout(function () {
      syncForm(form);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();

(function () {
  function patchSearchForms() {
    var predictive = window.MP && window.MP.routes && window.MP.routes.predictive
      ? window.MP.routes.predictive
      : '/search/suggest';

    document.querySelectorAll('[data-mps-search-form]').forEach(function (form) {
      form.dataset.predictiveUrl = predictive;
    });
  }

  patchSearchForms();
  document.addEventListener('shopify:section:load', patchSearchForms);
})();

/* MAXPROMO - sous-total panier fiable avec quantites */
(function () {
  'use strict';
  if (window.__MXP_CART_SUBTOTAL_V1__) return;
  window.__MXP_CART_SUBTOTAL_V1__ = true;

  var timer = null;
  var requestId = 0;

  function cartUrl() {
    var base = window.MP && window.MP.routes && window.MP.routes.cart
      ? window.MP.routes.cart
      : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
    return base + '.js';
  }

  function formatCartMoney(cents, currency) {
    var amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' EUR';
    }
  }

  function lineSubtotal(cart) {
    if (cart && Number.isFinite(Number(cart.items_subtotal_price))) {
      return Number(cart.items_subtotal_price);
    }
    return (cart && Array.isArray(cart.items) ? cart.items : []).reduce(function (sum, item) {
      var line = Number(item.final_line_price);
      if (Number.isFinite(line)) return sum + line;
      return sum + (Number(item.final_price) || 0) * (Number(item.quantity) || 0);
    }, 0);
  }

  function syncSubtotal() {
    if (!document.querySelector('[data-drawer-total]')) return;
    var currentRequest = ++requestId;
    fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart subtotal lookup failed');
        return response.json();
      })
      .then(function (cart) {
        if (currentRequest !== requestId) return;
        var subtotal = lineSubtotal(cart);
        document.querySelectorAll('[data-drawer-total]').forEach(function (el) {
          el.textContent = formatCartMoney(subtotal, cart.currency || 'EUR');
          el.setAttribute('data-mxp-line-subtotal', String(subtotal));
        });
      })
      .catch(function () {});
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(syncSubtotal, typeof delay === 'number' ? delay : 25);
  }

  function observeDrawer() {
    var lines = document.querySelector('[data-drawer-lines]');
    if (!lines || lines.getAttribute('data-mxp-subtotal-observed') === '1') return;
    lines.setAttribute('data-mxp-subtotal-observed', '1');
    new MutationObserver(function () { schedule(15); }).observe(lines, { childList: true, subtree: true });
  }

  function boot() {
    observeDrawer();
    schedule(0);
  }

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest('[data-qty-change]') : null;
    if (!control) return;
    setTimeout(function () { schedule(0); }, 120);
    setTimeout(function () { schedule(0); }, 360);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

/* MAXPROMO - quantites panier serialisees pour clics rapides */
(function () {
  'use strict';
  if (window.__MXP_CART_QTY_QUEUE_V1__) return;
  window.__MXP_CART_QTY_QUEUE_V1__ = true;

  var states = new Map();
  var running = false;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function changeUrl() {
    return window.MP && window.MP.routes && window.MP.routes.cart_change
      ? window.MP.routes.cart_change
      : routesRoot() + 'cart/change.js';
  }

  function cartUrl() {
    var base = window.MP && window.MP.routes && window.MP.routes.cart
      ? window.MP.routes.cart
      : routesRoot() + 'cart';
    return base + '.js';
  }

  function formatCartMoney(cents, currency) {
    var amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' EUR';
    }
  }

  function lineSubtotal(cart) {
    if (cart && Number.isFinite(Number(cart.items_subtotal_price))) {
      return Number(cart.items_subtotal_price);
    }
    return (cart && Array.isArray(cart.items) ? cart.items : []).reduce(function (sum, item) {
      var line = Number(item.final_line_price);
      if (Number.isFinite(line)) return sum + line;
      return sum + (Number(item.final_price) || 0) * (Number(item.quantity) || 0);
    }, 0);
  }

  function showToast(message) {
    var el = document.getElementById('Toast');
    if (!el || !message) return;
    el.textContent = message;
    el.dataset.open = 'true';
    setTimeout(function () { el.dataset.open = 'false'; }, 2600);
  }

  function renderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderDrawer(cart) {
    var list = document.querySelector('[data-drawer-lines]');
    var totalEl = document.querySelector('[data-drawer-total]');
    var empty = document.querySelector('[data-drawer-empty]');
    var foot = document.querySelector('[data-drawer-foot]');
    if (!list) return;

    if (!cart.items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    list.innerHTML = cart.items.map(function (item) {
      var image = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      return '<div class="cart-line">' +
        '<img class="cart-line__img" src="' + image + '" alt="" loading="lazy" width="64" height="64">' +
        '<div>' +
          '<a class="cart-line__name" href="' + item.url + '">' + item.product_title + '</a>' +
          (item.variant_title ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '') +
          '<div class="cart-line__variant">' + formatCartMoney(item.final_price, cart.currency || 'EUR') + ' &times; ' + item.quantity + '</div>' +
          '<div class="qty" style="margin-top:8px">' +
            '<button type="button" data-qty-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="-">&minus;</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" data-qty-input="' + item.key + '" aria-label="Quantity">' +
            '<button type="button" data-qty-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="+">+</button>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-qty-change="' + item.key + '" data-qty="0">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    if (totalEl) {
      var subtotal = lineSubtotal(cart);
      totalEl.textContent = formatCartMoney(subtotal, cart.currency || 'EUR');
      totalEl.setAttribute('data-mxp-line-subtotal', String(subtotal));
    }
  }

  function setBusy(value) {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.setAttribute('aria-busy', value ? 'true' : 'false');
  }

  async function postChange(key, quantity) {
    var response = await fetch(changeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    if (!response.ok) {
      var error = await response.json().catch(function () { return {}; });
      throw new Error(error.description || error.message || 'Impossible de mettre à jour le panier.');
    }
    return response.json();
  }

  async function getCart() {
    var response = await fetch(cartUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Impossible de rafraîchir le panier.');
    return response.json();
  }

  function nextPending() {
    var found = null;
    states.forEach(function (state, key) {
      if (!found && state.sent !== state.desired) found = { key: key, state: state };
    });
    return found;
  }

  function hasPending() {
    return !!nextPending();
  }

  function optimisticUpdate(control, quantity) {
    var line = control.closest('.cart-line');
    var wrap = control.closest('.qty') || (line && line.querySelector('.qty'));
    var input = wrap && wrap.querySelector('input');
    if (input) input.value = quantity;

    if (wrap) {
      wrap.querySelectorAll('[data-qty-change]').forEach(function (button) {
        var isPlus = String(button.textContent || '').indexOf('+') > -1;
        button.setAttribute('data-qty', String(isPlus ? quantity + 1 : Math.max(0, quantity - 1)));
      });
    }

    if (quantity === 0 && line) {
      line.querySelectorAll('button[data-qty-change]').forEach(function (button) {
        button.disabled = true;
      });
    }
  }

  async function drain() {
    if (running) return;
    running = true;
    setBusy(true);
    var lastCart = null;

    try {
      var next;
      while ((next = nextPending())) {
        var target = next.state.desired;
        next.state.sent = target;
        try {
          lastCart = await postChange(next.key, target);
        } catch (error) {
          next.state.sent = null;
          throw error;
        }
      }

      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
        return;
      }

      if (!lastCart) lastCart = await getCart();
      renderCount(lastCart.item_count);
      renderDrawer(lastCart);
      states.clear();
    } catch (error) {
      states.clear();
      try {
        var fresh = await getCart();
        renderCount(fresh.item_count);
        renderDrawer(fresh);
      } catch (ignore) {}
      showToast(error.message);
    } finally {
      setBusy(false);
      running = false;
      if (hasPending()) setTimeout(drain, 0);
    }
  }

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest('[data-qty-change]') : null;
    if (!control) return;
    if (!control.closest('#CartDrawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var key = control.getAttribute('data-qty-change');
    if (!key) return;

    var line = control.closest('.cart-line');
    var wrap = control.closest('.qty') || (line && line.querySelector('.qty'));
    var input = wrap && wrap.querySelector('input');
    var state = states.get(key);
    var current = state ? Number(state.desired) : Number(input && input.value);
    if (!Number.isFinite(current)) current = Number(control.getAttribute('data-qty')) || 0;

    var desired;
    if (control.classList.contains('cart-line__remove')) {
      desired = 0;
    } else {
      var delta = String(control.textContent || '').indexOf('+') > -1 ? 1 : -1;
      desired = Math.max(0, current + delta);
    }

    optimisticUpdate(control, desired);

    if (!state) {
      state = { desired: desired, sent: null };
      states.set(key, state);
    } else {
      state.desired = desired;
    }

    drain();
  }, true);
})();
